var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideError)?_c('div',{staticClass:"alert alert-danger text-center",class:{ 'hide': _vm.hideError},attrs:{"id":"errorContainer","role":"alert"}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v(" "+_vm._s(_vm.errorText)+" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }